
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFilter3Off as ObiFilter3OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-filter-3-off.js';
 
 
 

 
 export const ObiFilter3Off = createComponent({
   react: React,
   tagName: 'obi-filter-3-off',
   elementClass: ObiFilter3OffElement,
   events: {
     
   }
  });
 
 